import { Modal as StyledSheetOrModal } from '@hungryroot/ramen';
import styles from './FillingCartModal.module.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function FillingCartModal(props: Props) {
  const { isOpen, onClose } = props;

  return (
    <StyledSheetOrModal
      testid="filling-cart"
      body="We're still busy filling your cart with tasty groceries. Try again in a few minutes—your cart should be ready to edit by then!"
      onDismiss={onClose}
      onActionClick={onClose}
      heading="Whoops–give us a minute!"
      confirmButtonText="Got it"
      ariaLabel="still-filling-your-cart"
      isOpen={isOpen}
      className={styles.content}
    />
  );
}
